/** Quick method to round a floating number to 2 points. */
export var roundToTwo = function (value) {
  var result = Number(Math.round(parseFloat(value + 'e+2')) + 'e-2');
  return isNaN(result) ? value : result;
};
/** Takes an Order Item to return just the modifier cost on the item. */
export var modifierCostCalculation = function (item, includeTaxModifiers) {
  if (includeTaxModifiers === void 0) {
    includeTaxModifiers = true;
  }
  if (item.modifiers && item.modifiers.length) {
    return item.modifiers.filter(function (modifier) {
      return !!modifier.quantity;
    }).filter(function (modifier) {
      return includeTaxModifiers || modifier.taxPercent === null || modifier.taxPercent === undefined;
    }).map(function (modifier) {
      var amount = modifier.isPercentage ? item.cost * modifier.amount / 100 : modifier.amount;
      return modifier.quantity * (amount || 0);
    }).reduce(function (total, current) {
      return total + current;
    }, 0);
  }
  return 0;
};
/** Create blank booking object. */
export var createBlankBookingAmounts = function () {
  return {
    creditCardFees: 0,
    deposit: 0,
    depositIncFees: 0,
    discount: 0,
    fees: 0,
    feesTax: 0,
    giftCard: 0,
    paymentAmountIncCardFees: 0,
    postage: 0,
    subTotal: 0,
    subTotalTax: 0,
    tax: 0,
    taxExclusive: 0,
    total: 0,
    totalExcCardFees: 0,
    totalIgnoringDeposit: 0,
    transactionFees: 0
  };
};